export enum WREX_PLAY_VIDEO {
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=169164968 */
    PICK_FROM_VIDEO_GALLERY = 'PLAY.PICK_VIDEO_FROM_GALLERY',
}
